import { cn } from "../../../lib/utils";
import HorizontalScroll from "../../common/HorizontalScroll";
import DashboardSection from "./DashboardSection";

export default function BottomAreaTable() {
  const tableHeads = [
    "Timestamp",
    "Unit",
    "System",
    "Source",
    "Description",
    "Value",
    "Set point",
    "Model Type",
  ];
  return (
    <DashboardSection
      title="Site event"
      containerClassName=""
      className="overflow-hidden "
    >
      <div className="w-full max-h-[200px] overflow-auto custom-scrollbar">
        {" "}
        <table className="w-full text-[#242424] text-xs  max-h-[600px]  border border-[#B9B9B9]/30 border-t-0">
          <thead className="sticky top-0 z-10 bg-white ">
            <tr className="divide-x divide-[#B9B9B9]/30 ">
              {tableHeads.map((head, index) => (
                <th key={index} className="">
                  <div className="border-[#B9B9B9]/30 border-t py-[10.5px] bg-white ">
                    {head}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {new Array(10).fill(0).map((item, index) => (
              <tr
                className={cn(
                  "bg-[#eaeaea] divide-x divide-[#B9B9B9]/30 border-t border-[#B9B9B9]/30",
                  {
                    "bg-[#F1F1F1]": index % 3 === 2,
                  }
                )}
                key={index}
              >
                <TD className="w-[250px] max-w-[250px]">2022-11-24 20:00:00</TD>
                <TD>Unit2</TD>
                <TD>All</TD>
                <TD className="w-[250px] max-w-[250px]">02-TBN-BRG-ACC-H</TD>
                <TD className="w-[250px] max-w-[250px]">TBN BRG ACC H</TD>
                <TD>3.54</TD>
                <TD>3.31</TD>
                <TD className="w-[300px] max-w-[330px]">Early Warning Alarm</TD>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardSection>
  );
}

const TD = ({ children, className }) => {
  return (
    <td>
      <div
        className={cn(
          "py-[10.5px] px-4 text-xs leading-[100%] flex justify-center items-center gap-2.5  max-w-[200px] mx-auto",
          {
            [className]: className,
          }
        )}
      >
        {children}
      </div>
    </td>
  );
};
